import { useLang } from "@/context/LanguageContext";
import { SERVICES_IMG } from "@/data/content";
import { Reveal, Overline } from "@/components/shared";

export const WhyUs = () => {
  const { t } = useLang();
  const w = t.why;

  return (
    <section id="why" data-testid="why" className="border-t border-zinc-200 bg-zinc-50">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-24 sm:px-12 md:grid-cols-12 md:gap-16 md:py-32">
        <div className="md:col-span-6">
          <Reveal>
            <Overline>{w.overline}</Overline>
            <h2 className="mt-6 font-heading text-3xl font-light tracking-tight text-zinc-900 sm:text-5xl">
              {w.title}
            </h2>
            <p className="mt-8 text-base leading-relaxed text-zinc-600 sm:text-lg">{w.body}</p>
          </Reveal>

          <Reveal i={1}>
            <div className="mt-10 flex flex-wrap gap-3">
              {w.sectors.map((sec) => (
                <span
                  key={sec}
                  data-testid="why-sector"
                  className="border border-zinc-300 bg-white px-4 py-2 font-mono text-xs uppercase tracking-[0.12em] text-zinc-700"
                >
                  {sec}
                </span>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="md:col-span-6">
          <Reveal i={1}>
            <div className="relative overflow-hidden">
              <img src={SERVICES_IMG} alt="" className="aspect-square w-full object-cover" />
              <div className="absolute inset-0 bg-zinc-900/10" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
